import { useAuth } from '@/auth/hooks/useAuth';
import { Avatar, AvatarFallback } from '@/common/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from '@/common/components/ui/dropdown-menu';
import { getInitials } from '@/common/utils/UserUtils';

import ProfileDropdownMenu from './ProfileDropdownMenu';

export default function ProfileButton() {
  const { user } = useAuth();

  const displayName = user?.name || 'User';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-x-2 rounded-lg px-4 py-2 transition-colors cursor-pointer hover:bg-black/30 focus:outline-none focus:ring-2 focus:ring-terre-600 focus:ring-offset-2"
        >
          <div className="text-sm text-warm-gray-50">{displayName}</div>
          <Avatar className="h-8 w-8">
            <AvatarFallback className="bg-warm-gray-50 text-xs text-terre-800">
              {getInitials(displayName)}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <ProfileDropdownMenu />
    </DropdownMenu>
  );
}
